const { getElement, getElements } = window.BAO.Utils

export class SiteDrawers extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    this._activeDrawerKey = ''
    this._secondaryDrawerKey = ''
    this.drawers = []

    window.drawers = this

    this.drawerKeys
      .filter((key) => !this.triggerKeys.includes(key))
      .forEach((key) =>
        console.info(`Drawer exists for ${key} but there is no trigger`),
      )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.activeDrawerKey = ''
      }
    })

    // Listen for custom drawer open events
    this.listeners.add(document, 'drawer:open', (e) => {
      if (e.detail && e.detail.key) {
        this.activeDrawerKey = e.detail.key
      }
    })

    // Listen for custom drawer close events
    this.listeners.add(document, 'drawer:close', () => {
      this.activeDrawerKey = ''
    })
  }

  handleClick (e) {
    const EVENTS = {
      TRIGGER: 'TRIGGER',
      CLOSE: 'CLOSE',
      BACKDROP: 'BACKDROP',
      SUBNAV: 'SUBNAV',
      SUBNAVBACK: 'SUBNAVBACK',
      ASIDE: 'ASIDE',
      UNKNOWN: 'UNKNOWN',
    }

    const eventType = (() => {
      if (e.target.closest(this.config.matches.trigger) !== null) {
        return EVENTS.TRIGGER
      } else if (e.target.closest(this.config.matches.close) !== null) {
        return EVENTS.CLOSE
      } else if (e.target.closest(this.config.matches.aside) !== null) {
        return EVENTS.ASIDE
      } else if (e.target.closest(this.config.matches.subNav) !== null) {
        return EVENTS.SUBNAV
      } else if (e.target.closest(this.config.matches.subNavBack) !== null) {
        return EVENTS.SUBNAVBACK
      } else if (e.target.closest(this.config.matches.backdrop) !== null) {
        return EVENTS.BACKDROP
      } else if (e.target.closest(this.config.matches.drawer) !== null) {
        if (e.detail !== 0) {
          const dialogDimensions = e.target
            .closest(this.config.matches.drawer)
            .getBoundingClientRect()

          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            return EVENTS.BACKDROP
          }
        }
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN || eventType === EVENTS.ASIDE) return
    e.preventDefault()

    if (eventType === EVENTS.TRIGGER) {
      const trigger = e.target.closest(this.config.matches.trigger)
      const key = trigger.getAttribute('data-drawers-trigger')

      // For product-quick-add, don't open immediately - let the component handle it via custom event
      if (key !== 'product-quick-add') {
        this.activeDrawerKey = key === this.activeDrawerKey ? '' : key
      }
    }

    if (eventType === EVENTS.CLOSE || eventType === EVENTS.BACKDROP) {
      this.activeDrawerKey = ''
    }
  }

  /**
   * @param {string} key
   */
  open (key) {
    this.activeDrawerKey = key
  }

  close () {
    this.activeDrawerKey = ''
  }

  get triggerKeys () {
    return getElements('[data-drawers-trigger]').map((el) =>
      el.getAttribute('data-drawers-trigger'),
    )
  }

  get drawerKeys () {
    return getElements('[data-module-drawers-drawer]').map((el) =>
      el.getAttribute('data-module-drawers-drawer'),
    )
  }

  get hasAlreadyBeenUsed () {
    const el = getElement(this.nodeName.toLowerCase())

    return el !== this
  }

  get aDrawerIsOpen () {
    return this.drawers.some((drawer) => drawer.isOpen)
  }

  get activeDrawerKey () {
    return this._secondaryDrawerKey || this._activeDrawerKey
  }

  set activeDrawerKey (key) {
    const secondaryDrawerKeys = [
      'packaging-information',
      'gifting-drawer',
    ]
    const isSecondaryDrawerKey = (drawerKey) =>
      secondaryDrawerKeys.includes(drawerKey) ||
      drawerKey.startsWith('product-upsell-')

    if (isSecondaryDrawerKey(key)) {
      if (key === this._secondaryDrawerKey) {
        this._secondaryDrawerKey = ''
      } else if (this._activeDrawerKey && !isSecondaryDrawerKey(this._activeDrawerKey)) {
        this._secondaryDrawerKey = key
      } else {
        this._activeDrawerKey = ''
        this._secondaryDrawerKey = key
      }
    } else if (key === '') {
      if (this._secondaryDrawerKey) {
        this._secondaryDrawerKey = ''
      } else {
        this._activeDrawerKey = ''
      }
    } else {
      this._secondaryDrawerKey = ''
      this._activeDrawerKey = key
    }

    const baseKey = this._activeDrawerKey
    const overlayKey = this._secondaryDrawerKey

    this.drawers.forEach((drawer) => {
      const isSecondaryDrawer = isSecondaryDrawerKey(drawer.key)

      drawer.isOpen = isSecondaryDrawer
        ? drawer.key === overlayKey
        : drawer.key === baseKey
    })

    const hasAnyOpenDrawer = baseKey !== '' || overlayKey !== ''

    this.config.elements.drawers.classList.toggle(
      this.config.classes.activeClass,
      hasAnyOpenDrawer,
    )
    document.body.classList.toggle(
      this.config.classes.siteOverflowed,
      hasAnyOpenDrawer,
    )
    document.body.classList.toggle(
      this.config.classes.drawersOpenUtility,
      hasAnyOpenDrawer,
    )

    if (hasAnyOpenDrawer) {
      this.els.drawer.element.classList.add('drw-Drawers_Drawer-active')
      document.body.classList.remove(
        ...Array.from(document.body.classList).filter((className) =>
          className.startsWith('drw-Drawers-'),
        ),
      )
      document.body.classList.add(
        `drw-Drawers-${overlayKey || baseKey}`,
      )
    } else {
      this.els.drawer.element.classList.remove('drw-Drawers_Drawer-active')
      document.body.classList.remove(
        ...Array.from(document.body.classList).filter((className) =>
          className.startsWith('drw-Drawers-'),
        ),
      )
    }

    document.dispatchEvent(new CustomEvent('drawer-changed'))
  }

  get config () {
    return {
      matches: {
        trigger: '[data-drawers-trigger]',
        subNav: '[data-drawers-sub-nav]',
        subNavBack: '[data-drawers-sub-nav-back]',
        close: '[data-drawers-close]',
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawer: '[is="site-drawer"]',
        aside: '[is="site-drawer"] .drw-Drawer_Aside',
      },
      classes: {
        activeClass: 'drw-Drawers-active',
        activeDrawerClass: 'drw-Drawer-active',
        siteOverflowed: 'util-SiteOverflowed',
        drawersOpenUtility: 'util-DrawersOpen',
      },
      elements: {
        body: document.body || document.documentElement,
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawers: document.querySelector('site-drawers'),
      },
    }
  }
}

customElements.define('site-drawers', SiteDrawers)
